module.exports = __webpack_public_path__ + "img/419.c57715bf.jpg";